<app-change-itemized-billing (back)="resetWorkflowAndRedirect()"
                             *ngIf="subscription"
                             (selected)="onItemizedBillingChanged($event)"></app-change-itemized-billing>
